exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/node_modules/postcss-loader?{"ident":"postcss"}!C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles